import { Action } from '@ngrx/store';
import { UserClaims } from '@okta/okta-auth-js';
export const TOKEN_LOADED = '[Auth] Token Loaded';
export const LOG_OUT = '[Auth] Log Out';
export const LOGGED_OUT = '[Auth] Logged Out';

export class TokenLoaded implements Action {
  public readonly type = TOKEN_LOADED;
  constructor(public readonly token: string, public readonly oktaClaims: UserClaims) {}
}

export class LoggedOut implements Action {
  public readonly type = LOGGED_OUT;
}

export class LogOut implements Action {
  public readonly type = LOG_OUT;
}

export type All = LoggedOut | TokenLoaded | LogOut;
